import home from './home/routes'

export default [...home]


// WEBPACK FOOTER //
// ./src/app/routes.js